import { SurveyEventAnswer } from "./actionModule/subtypes/surveyAppointmentModels";
import { EmployeeGeneral } from "./employeeType";

export const ServiceModuleTypes = {
    Calendar: "Calendar",
    Folder: "Folder",
    File: "File",
    Text: "Text",
    Url: "Url",
    Leaderboard: "Leaderboard",
    Timetracking: "Timetracking",
    Absence: "Absence",
} as const;

export enum RankingOrder {
    SmallerIsBetter = "SmallerIsBetter",
    BiggerIsBetter = "BiggerIsBetter"
}

export type ServiceModuleType = keyof typeof ServiceModuleTypes;

export interface ServiceModule {
    id: number;
    name: string;
    iconName: string;
    colorHex: string | null;
    iconUrl: string | null;
    isVisible: boolean;
    order: number;
    type: string;
    sendNotification: boolean;
    isCompanyWideAssigned: boolean;
    parentFolderServiceModuleId?: number;
    assignedGroupIds: number[];
}

export type AllServiceModule =
    CalendarServiceModule
    | FolderServiceModule
    | FileServiceModule
    | TextServiceModule
    | UrlServiceModule;

export enum YearlyEventVisibility {
    Hidden = "Hidden",
    Visible = "Visible",
    VisibleWithYear = "VisibleWithYear"
}

export interface CalendarServiceModule extends ServiceModule {
    type: typeof ServiceModuleTypes.Calendar;
    birthdayVisibility: YearlyEventVisibility;
    anniversaryVisibility: YearlyEventVisibility;
    hasSurveyAppointmentSubtypes: boolean;
}
export interface FolderServiceModule extends ServiceModule {
    type: typeof ServiceModuleTypes.Folder;
}
export interface FileServiceModule extends ServiceModule {
    type: typeof ServiceModuleTypes.File;
    filename: string;
    path: string;
}
export interface TextServiceModule extends ServiceModule {
    type: typeof ServiceModuleTypes.Text;
    text: string;
}
export interface UrlServiceModule extends ServiceModule {
    type: typeof ServiceModuleTypes.Url;
    url: string;
}
export interface LeaderboardServiceModule extends ServiceModule {
    type: typeof ServiceModuleTypes.Leaderboard;
    entry: LeaderboardEntry[];
    assignedActionModuleIds: number[];
    rankingOrder: RankingOrder;
}
export interface TimeTrackingServiceModule extends ServiceModule {
    type: typeof ServiceModuleTypes.Timetracking;
}
export interface AbsenceServiceModule extends ServiceModule {
}

export type CalendarEvent = {
    id?: number;
    title: string;
    description: string;
    capacity: number | null;
    eventType?: "Birthday" | "Anniversary" | "Basic" | "Absence";
    startDate: string;
    endDate: string;
    iconName: string;
    colorHex: string;
    iconUrl: string | null;
    hasTime: boolean;
    isCompanyWideAssigned: boolean;
    assignedGroupIds: number[];
    sendUpdateNotification?: boolean;
    reminderNotifications?: string[];
    years?: number | null;
    surveyAppointmentAllowed?: boolean;
    surveyAppointmentReward?: number | null;
};

export type CalendarEventSurveyAnswer = {
    employee: EmployeeGeneral;
    answer: SurveyEventAnswer;
    selectionTimestamp: string;
}

export interface ServiceModuleFile {
    id: number;
    type: 'file';
    content: string;
}

export interface LeaderboardEntry {
    id?: number;
    firstName: string;
    lastName: string;
    employeeNumber: string;
    position: string;
    status: string;
    score: number;
    rank: number;
}

export interface LeaderboardTable {
    totalCount: number;
    items: LeaderboardEntry[]
}

export const defaultIconsByType: Record<string, string> = {
    [ServiceModuleTypes.Folder]: "folder",
    [ServiceModuleTypes.Leaderboard]: "leaderboard",
    [ServiceModuleTypes.Text]: "text",
    [ServiceModuleTypes.Url]: "url",
    [ServiceModuleTypes.Calendar]: "calendar month",
    [ServiceModuleTypes.File]: "file",
    [ServiceModuleTypes.Timetracking]: "timetracker",
    [ServiceModuleTypes.Absence]: "calendar month",
};
